import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const PageContainer = styled.div`
    min-height: 100vh;
    padding: 120px 20px 60px;
    background: #1a1a3e;
    color: #f4d4a3;
    display: flex;
    justify-content: center;
    align-items: flex-start;
`;

const Content = styled.div`
    max-width: 960px;
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const Title = styled.h1`
    font-size: 2.8rem;
    margin: 0;
    font-weight: 800;
    letter-spacing: 1px;
    text-shadow: 0 2px 10px rgba(244, 212, 163, 0.25);

    @media (max-width: 768px) {
        font-size: 2.2rem;
    }
`;

const Subtitle = styled.p`
    font-size: 1.2rem;
    margin: 0;
    opacity: 0.9;
`;

const Description = styled.p`
    font-size: 1rem;
    margin: 0;
    opacity: 0.8;
    max-width: 720px;
    width: 100%;
    align-self: center;
    line-height: 1.6;
`;

const CardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 20px;
    width: 100%;
    margin-top: 10px;
`;

const ActionCard = styled(Link)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 20px;
    background: rgba(244, 212, 163, 0.08);
    border: 1px solid rgba(244, 212, 163, 0.2);
    border-radius: 12px;
    color: #f4d4a3;
    text-decoration: none;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &:hover {
        background: rgba(244, 212, 163, 0.12);
        border-color: rgba(244, 212, 163, 0.35);
        transform: translateY(-2px);
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
    }
`;

const Emoji = styled.span`
    font-size: 1.8rem;
`;

const CardTitle = styled.span`
    font-size: 1.3rem;
    font-weight: 700;
    display: block;
`;

const CardDescription = styled.span`
    font-size: 0.98rem;
    opacity: 0.8;
    line-height: 1.5;
    text-align: left;
`;

const ComingSoon = styled.p`
    margin-top: 10px;
    font-size: 0.95rem;
    opacity: 0.6;
`;

const LanguageLearningPage = () => {
    const { t } = useTranslation();

    return (
        <PageContainer>
            <Content>
                <Title>{t('languageLearning.title')}</Title>
                <Subtitle>{t('languageLearning.subtitle')}</Subtitle>
                <Description>{t('languageLearning.description')}</Description>

                <CardGrid>
                    <ActionCard to="/word-game" state={{ fromHome: true }}>
                        <Emoji>🎴</Emoji>
                        <CardTitle>{t('languageLearning.gojuonGenius')}</CardTitle>
                        <CardDescription>{t('languageLearning.gojuonGeniusDesc')}</CardDescription>
                    </ActionCard>
                </CardGrid>

                <ComingSoon>{t('languageLearning.comingSoon')}</ComingSoon>
            </Content>
        </PageContainer>
    );
};

export default LanguageLearningPage;




